import SectionTitle from "./common/SectionTitle";
import { AWARDS } from "../constants/data";
import { useInView } from "../hooks/useInView";

export default function Awards() {
  const [awardsRef, awardsVis] = useInView();

  return (
    <div id="awards" style={{ padding: "80px 20px", background: "white" }}>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <SectionTitle
          tag="Recognition"
          title="Awards & Achievements"
          sub="Recognising clinical excellence and contributions to nephrology"
        />

        <div
          ref={awardsRef}
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 18,
            opacity: awardsVis ? 1 : 0,
            transform: awardsVis ? "translateY(0)" : "translateY(30px)",
            transition: "all 0.7s ease",
          }}
        >
          {AWARDS.map((award, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                gap: 18,
                background: "linear-gradient(135deg,#eff6ff,#f0fdf9)",
                border: "1px solid #dbeafe",
                borderRadius: 20,
                padding: "24px 22px",
                transition: "box-shadow 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow =
                  "0 8px 24px rgba(29,78,216,0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <div
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: 16,
                  background: "linear-gradient(135deg,#1d4ed8,#0d9488)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 22,
                  flexShrink: 0,
                  boxShadow: "0 4px 12px rgba(29,78,216,0.25)",
                }}
              >
                🏆
              </div>
              <div>
                <div
                  style={{
                    fontSize: 12,
                    color: "#0d9488",
                    fontWeight: 700,
                    marginBottom: 4,
                  }}
                >
                  {award.year}
                </div>
                <div
                  style={{
                    fontWeight: 700,
                    color: "#1e293b",
                    fontSize: 14,
                    marginBottom: 4,
                  }}
                >
                  {award.title}
                </div>
                <div style={{ color: "#64748b", fontSize: 12 }}>
                  {award.org}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
